// src/components/quizzes/kit/tapFx.js
//
// Confetti for a single tap in a bonus round.
//
// canvas-confetti draws every particle from JavaScript on the page's main
// thread. One burst is nothing, but a child tapping fast on a phone set off
// several at once and the whole round hitched with each one. So:
//   * phones and small tablets: no confetti per tap (the score pop and the
//     tap ring already say "got it"); the big finish confetti stays
//   * everything else: the confetti is drawn in a background worker on its
//     own canvas, so it can't hold up the falling items or the next tap

import confetti from "canvas-confetti";

const isSmallTouch = () => {
  try {
    return window.matchMedia("(pointer: coarse)").matches && Math.min(window.innerWidth, window.innerHeight) < 820;
  } catch {
    return false;
  }
};

let shoot = null;
const shooter = () => {
  if (shoot) return shoot;
  try {
    const canvas = document.createElement("canvas");
    Object.assign(canvas.style, { position: "fixed", inset: "0", width: "100%", height: "100%", pointerEvents: "none", zIndex: "9999" });
    document.body.appendChild(canvas);
    shoot = confetti.create(canvas, { resize: true, useWorker: true, disableForReducedMotion: true });
  } catch {
    shoot = confetti;
  }
  return shoot;
};

export const tapConfetti = (opts) => {
  if (typeof window === "undefined" || isSmallTouch()) return;
  try {
    shooter()(opts);
  } catch {
    /* never let a decoration break the game */
  }
};

export default tapConfetti;
